import isEmpty from "lodash.isempty";

export const apiPathFn = (api: string) => (path: string[] = []) : string => {
    path = path.filter(str => !isEmpty(str));
    return [api, ...path].join('/')
}; 
